<template>
    <div style="display: flex; flex-direction: column; gap: 50px; margin-top: 16px">
       <el-row>
            <el-col :span="12">
                <h2 style="margin-top: 0px !important;">Main Contact</h2>
                <p>The system will invite the main contact into the customer portal when the proposal is signed.</p>

                <el-form-item>
                    <el-input v-model="tab_form.contact_name" placeholder="Name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="tab_form.contact_email" placeholder="Email"></el-input>
                </el-form-item>
                <el-checkbox v-model="tab_form.grant_portal_access">Grant Employer access to Bluegrass</el-checkbox>
            </el-col>
            <el-col :span="12" style="display: flex; justify-content: end">
                <template v-if="proposal.prospect_id">
                    <btn cssClass="btn btn-secondary" icon="far fa-address-card" :click="() => show_modal = true">Open Contact List</btn>

                    <prospect-detail 
                        v-if="show_modal"
                        :prospect_id="proposal.prospect_id" 
                        tab="contacts"
                        @closed="show_modal=false"
                    />
                </template>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24">
                <h2>Business</h2>
                <el-radio-group v-model="tab_form.renewal_type">
                    <el-radio :label="0">New business</el-radio><br>
                    <el-radio :label="2">Renewal - this month</el-radio><br>
                    <el-radio :label="1">Renewal - next month</el-radio><br>
                </el-radio-group>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24">
                <h2>Term</h2>
                <el-radio-group v-model="tab_form.term_length">
                    <el-radio :label="1">Month-to-Month</el-radio><br>
                    <el-radio :label="3">3 Months</el-radio><br>
                    <el-radio :label="6">6 Months</el-radio><br>
                    <el-radio :label="12">12 Months</el-radio>
                </el-radio-group>
            </el-col>
        </el-row>
    
        <el-row>
            <el-col :span="24">
                <h2>Billing</h2>

                <el-radio-group v-model="tab_form.billing_method">
                    <el-radio label="credit-card">Credit Card</el-radio><br>
                    <el-radio label="invoice">Invoice</el-radio><br>
                </el-radio-group>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import ProspectDetail from "./../../../Prospects/vue/prospect-detail.vue";

export default {
    components: {
        ProspectDetail
    },
    props: {
        proposal: {
            type: Object,
            required: true
        },
        tab_form: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            show_modal: false,
        };
    },
    methods: {
    },
    mounted() {
    }
}
</script>
